// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__35C9G","inputWrap":"Table_inputWrap__1dOeV","col":"Table_col__blmHl","bmiTooltip":"Table_bmiTooltip__2RGpi"};